import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import TournamentForm from './createMajorComponent'; // Adjust the path based on your file structure

interface TournamentWrapperProps {
  onTournamentCreated: () => void; // Callback function to refetch tournaments
}

const TournamentWrapper: React.FC<TournamentWrapperProps> = ({ onTournamentCreated }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <button className="bga-btn bga-btn-primary" onClick={handleShow}>
        + Create a Tournament
      </button>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18, fontWeight: 700 }}>Create Tournament</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '20px 22px 24px' }}>
          <TournamentForm onTournamentCreated={onTournamentCreated} handleClose={handleClose} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default TournamentWrapper;
